import React from 'react';
import HouseList from '../components/HouseList';
import Banner from '../components/Banner';

const Home = () => {
  return (
    <>
      <Banner />
      <HouseList />
    </>
  );
};

export default Home;
